import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  CardNumberElement,
  CardCVCElement,
  CardExpiryElement,
  injectStripe,
} from 'react-stripe-elements';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { useTheme, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import Alert from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Alert';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { useSubscriptionSetupContext } from '../../SubscriptionSetupContext';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
  ccForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
});

const CreditCardForm = ({
  className,
  classes,
  stripe,
}) => {
  const {
    stripeErrorMessage,
    // isPaymentAuthorized,
    handleProcessPayment,
    isCreatingStripeToken,
  } = useSubscriptionSetupContext();
  const theme = useTheme();

  const stripeElementStyle = {
    base: {
      '::placeholder': {
        color: theme.palette.facet.primaryBlue,
        fontWeight: theme.typography.fontWeightBold,
      },
      fontSize: '16px',
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.facet.primaryBlue,
    },
  };

  return (
    <Box
      className={classNames(classes.root, 'CreditCardForm', className)}
    >
      {stripeErrorMessage ? (
        <Alert
          variant="filled"
          severity="error"
          className={classes.alert}
          test={'stripe-error-alert'}
        >
          <Typography
            variant={'h5'}
            weight={'bold'}
            color={'inherit'}
            test={'stripe-error-alert-text'}
          >
            {stripeErrorMessage}
          </Typography>
        </Alert>
      ) : null}
      <form
        className={classes.ccForm}
        onSubmit={() => {
          handleProcessPayment(stripe);
        }}
      >
        <CardNumberElement
          className={'StripeCardNumberInput'}
          placeholder={'Card Number'}
          style={stripeElementStyle}
        />
        <CardExpiryElement
          className={'StripeCardExpiryInput'}
          placeholder={'Expiration Date'}
          style={stripeElementStyle}
        />
        <CardCVCElement
          placeholder={'Security Code'}
          style={stripeElementStyle}
        />
        <RoundedButton
          variant={'contained'}
          color={'primary'}
          disableElevation
          onClick={async () => {
            await handleProcessPayment(stripe);
          }}
          isLoading={isCreatingStripeToken} // Show the loading spinner here until we're ready to show the full screen loader
          size={DS_SIZE_MAP.sm}
          fullWidth
          test={'subscription-setup-submit-payment-button'}
        >
          {'Submit Payment'}
        </RoundedButton>
      </form>
    </Box>
  );
};

CreditCardForm.defaultProps = {
  className: '',
};

CreditCardForm.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  stripe: PropTypes.object.isRequired,
};

export default (injectStripe(withStyles(styles)(CreditCardForm)));
